import { ProducerPreview } from '../model';

/** The currently selected company/site (D6) — only the MANUAL-site branch needs it. */
export interface SelectedCompanySite {
  company?: { id: string };
  site?: { id: string };
}

/**
 * Deep link to a producer's site-maintenance / chain-edit page, or `null` when it must render as
 * plain text instead (app#234 rule, fail-closed): a wrong `true` here would produce a link that
 * 403s, so absence of an explicit `mayWrite === true` means no link at all.
 *
 * Same rule and shapes as `ReportDetailChainArticleComponent.gapLink` (D3/D6). Extracted so
 * `TracesDdsConfirmSubmitDialogComponent.gapLink` and `TracesRejectionListComponent` share one
 * implementation instead of two copies that drift.
 */
export function producerSiteLink(producer: ProducerPreview, selected?: SelectedCompanySite): unknown[] | null {
  if (producer.mayWrite !== true || !producer.siteId) return null;
  if (producer.siteKind === 'COMPANY_SITE') {
    return producer.companyId
      ? ['/company', producer.companyId, 'site', producer.siteId, 'manage', 'update-site']
      : null;
  }
  if (producer.siteKind === 'MANUAL') {
    const { company, site } = selected ?? {};
    if (!company?.id || !site?.id || !producer.chainRootProductId || !producer.productId) return null;
    return ['/company', company.id, 'site', site.id, 'chain', producer.chainRootProductId, 'edit', producer.productId];
  }
  return null;
}
